module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "spw-text-and-image-m.5ece8c2e.svg";